import React from 'react'
import Layout from '../utils/layout'
import Seo from '../utils/seo'
import { sortComponents, hideComponents } from '../utils/helpers'
import Top from '../components/HomePageV6/Top'
import Product from '../components/HomePageV6/Product'
import HowItWorks from '../components/HomePageV6/HowItWorks'
import Warranty from '../components/Shared/Warranty'
import Reviews from '../components/HomePageV6/Reviews'
import Faq from '../components/HomePageV6/Faq'

export const Head = ({ location, pageContext }) => <Seo location={location} pageContext={pageContext} />

const HomePageV6 = ({ pageContext: { data } }) => {
  const components = [
    {
      render: i => <Product product={data.product} key={i} />,
      priority: data.product?.priority || 99,
      hidden: !data.product || data.product.isHide,
    },
    {
      render: i => <HowItWorks howItWorks={data.howItWorks} key={i} />,
      priority: data.howItWorks?.priority || 99,
      hidden: !data.howItWorks || data.howItWorks.isHide,
    },
    {
      render: i => <Warranty warranty={data.warranty} key={i} />,
      priority: data.warranty?.priority || 99,
      hidden: !data.warranty || data.warranty.isHide,
    },
    {
      render: i => <Reviews reviews={data.reviews} key={i} />,
      priority: data.reviews?.priority || 99,
      hidden: !data.reviews || !data.reviews.reviewList.title || data.reviews.isHide,
    },
    {
      render: i => <Faq faq={data.faq} key={i} />,
      priority: data.faq?.priority || 99,
      hidden: !data.faq || data.faq.isHide,
    },
  ]
    .filter(hideComponents)
    .sort(sortComponents)

  return (
    <Layout data={data}>
      {data.Top && <Top top={data.Top} />}
      {components.map((component, i) => component.render(i))}
    </Layout>
  )
}

export default HomePageV6
